import {useState, useEffect} from 'react';

const useSidebarMinimized = (): boolean => {
    const [isMinimized, setIsMinimized] = useState(
        document.body.getAttribute('data-kt-app-sidebar-minimize') === 'on'
    );

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setIsMinimized(document.body.getAttribute('data-kt-app-sidebar-minimize') === 'on');
        });
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['data-kt-app-sidebar-minimize'],
        });
        return () => observer.disconnect();
    }, []);

    return isMinimized;
};

export {useSidebarMinimized};
